import { useEffect, useRef } from 'react';

import { Playdeck, SendAnalitics } from '../lib/playdeck';

import { useSessionFinishedData } from './session-finished-data';

const useAppClose = (): void => {
  const getSessionData = useSessionFinishedData();
  const hasFired = useRef(false);

  useEffect(() => {
    const handleClose = (): void => {
      if (hasFired.current) return;
      hasFired.current = true;

      const data = getSessionData();
      SendAnalitics.sessionFinished(data);
      Playdeck.gameEnd();
    };

    const handleVisibilityChange = (): void => {
      if (document.visibilityState === 'hidden') {
        handleClose();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('pagehide', handleClose);
    window.addEventListener('beforeunload', handleClose);

    return (): void => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pagehide', handleClose);
      window.removeEventListener('beforeunload', handleClose);
    };
  }, [getSessionData]);
};

export { useAppClose };
